import axios from "axios";

const BASE_ORIGIN =
  process.env.NODE_ENV === "production"
    ? window.location.origin
    : "https://www.cyberway.com.cn";

console.log('BASE_ORIGIN', BASE_ORIGIN, process.env)

const service = axios.create({
  baseURL: BASE_ORIGIN + "/api/cyberway-website/website/",
  timeout: 1000 * 60
});

service.interceptors.request.use(config => {
  return config;
});

service.interceptors.response.use(response => {
  return response.data;
});

export default function request(options) {
  return service(options);
}



// WEBPACK FOOTER //
// ./src/api/index.js